import src from "IMAGE";
export default { src, width: 2786, height: 216, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ABoaGi8OITVJCg0VFxIIJS0ZCyIuKgwKJxcICBIQCQgMOmYDG7+ktrcAAAAASUVORK5CYII="};
